<template>
    <div>
        <Error404 v-if="display404"></Error404>
        <div v-else>
            <header-title-button
                :title="id ? disabledForm ?  'Item Detail' : 'Edit Item' : 'Add Item' "
                :isAdd="false">
            </header-title-button>

            <box
                :back="back"
                title="Item Information"
                :save="!disabledForm"
                :saveText="form.id ? `Edit` : `Save`"
                @onSave="doSaveConfirm"
                :loading="is_loading"
                :remove="false"
                :isSwitch="true"
                :switchValue="form.is_active"
                :switchDisabled="disabledForm"
                switchTitle="Status"
                :switchText="form.is_active ? 'Active' : 'Not Active' "
                @onSwitchButton="changeBtnSwitch">
                <div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group" :class="{'has-error': !!errors.name}">
                                <label class="control-label">Name 
                                    <span class="warning-text-required">*</span>
                                </label>
                                <input type="text" class="form-control name"
                                    id="name"
                                    v-model="form.name"
                                    :disabled="disabledForm"
                                    maxlength="20" />

                                    <p class="help help-block" v-if="errors.name">{{  form.name ? `Item name must be at least three characters, maximum twenty characters.` : `Item name is required.` }}</p>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group" :class="{'has-error': !!errors.category}">
                                <label class="control-label" >Category 
                                    <span class="warning-text-required">*</span>
                                </label>
                                <select type="text" class="form-control select2 select-category"
                                    style="width: 100%"
                                    id="location"
                                    v-model="form.category"
                                    :disabled="disabledForm" >
                                    <option v-for="(data, i) in category" :key="i" :value="data.name">{{ data.name }}</option>
                                </select>
                                
                                <p class="help help-block" v-if="errors.category">Category is required.</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group" :class="{'has-error': !!errors.description}">
                                <label class="control-label">Description 
                                    <span class="warning-text-required">*</span>    
                                </label>
                                <textarea 
                                    class="form-control description" 
                                    id="description" 
                                    v-model="form.description"
                                    maxlength="255"
                                    rows="7"
                                    :disabled="disabledForm">
                                </textarea>
                                <p>{{ calculate_description }}/255</p>

                                <p class="help help-block" v-if="errors.description">{{  form.description ? `Description must be at least three characters, maximum two hundred fifty-five characters.` : `Description is required.` }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group" :class="{'has-error': !!errors.item_images}">
                                <label class="control-label">Item Images 
                                    <span class="warning-text-required">*</span>
                                </label>
                                <ImageUpload 
                                    :image="image_path ? image_path : ''  "
                                    @onChangeUploadImage="changeUploadImage"
                                    @onChangeDeleteImage="changeDeleteImage"
                                    :disabled="image_disabled"/>
                            </div>
                        </div>
                    </div>
                    <br>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                    <div class="row">
                        <div class="inline-div" v-for="(data, i) in form.item_images" :key="i" >
                            
                            <div class="div-item-image" >
                                
                                <div class="cursor-pointer btn-add-item-image" v-if="!data.image_path">
                                    <img src="@/assets/svg/plus-circle.svg" @click="addItemImage(i)"/>
                                </div>
                                <div v-else>
                                    <img :class="`cursor-pointer image-preview-${i}`" 
                                        :src="imageUrl(data)" 
                                        width="115" 
                                        height="105" 
                                        style="padding: 1px; border-radius: 4px;"
                                        @click="showImage(data.image_path, i)" />
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group" :class="{'has-error': !!errors.item_images}">
                                <p class="help help-block" v-if="errors.item_images">Item images is required.</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <input 
                                type="file" 
                                id="upload-item-image" 
                                class="upload-item-image"
                                name="upload-item-image" 
                                accept="image/png, image/jpeg, image/jpg" 
                                @change="uploadAddItemImageChange()"/>
                        </div>
                    </div>
                </div>
            </box>
        </div>

        <modal :title="form.id ? 'Change Confirmation' : 'Add Confirmation' " save="true" remove="false"
            :show="is_confirm"
            :saveText=" form.id ? 'Yes, Confirmation' : 'Save'"
            @hidden="is_confirm = false"
            @onSave="doSave()"
            :loading="is_confirm_loading">
            <span class="span-title">Are you sure you want to modify the item ?</span>
        </modal>
    </div>
</template>

<script>
import Error404 from '@pages/Error404.vue'
import ImageUpload from '@app/components/ImageUpload.vue'
const {console} = window
export default {
    components: {
        Error404,
        ImageUpload
    },
    data() {
        return {
            back: this.$route.query.back ? this.$route.query.back : 'master.item',
            alias: 'item',
            id: this.$route.params.id,
            is_edit: false,
            disabledForm: false,
            display404: false,
            page: {
                title: 'Nuanu',
                subtitle: 'Item'
            },
            form: {
                id: this.$route.params.id,
                name: null,
                category: null,
                description: null,
                is_active: true,
                item_images: [
                    {
                        image_path: null,
                        is_new: true,
                        is_errors: false ,
                        file: null,
                    }, 
                    {
                        image_path: null,
                        is_new: true,
                        is_errors: false,
                        file: null,
                    }, {
                        image_path: null,
                        is_new: true,
                        is_errors: false,
                        file: null,
                    }, {
                        image_path: null,
                        is_new: true,
                        is_errors: false,
                        file: null,
                    }, {
                        image_path: null,
                        is_new: true,
                        is_errors: false,
                        file: null,
                    }
                ],
                
            },
            errors: {
                name: false,
                category: false,
                description: false,
                item_images: false,
            },
            is_confirm: false,
            is_confirm_loading: false,
            is_loading: false,
            category: [
                {name: 'Add-Ons'},
                {name: 'Ticket'}
            ],
            image_disabled: true,
            image_path: null,
            item_image_index: null,
            base_url: process.env.VUE_APP_UPLOAD_URL,
            item_image_add_index: null,
            is_success_upload: false
        }
    },
    async mounted() {
        this.$root.checkingAccessPage(this.$root._route.name)
        if(this.id)  {
            switch(this.$route.query.is_edit) {
                case true: 
                    this.is_edit = true 
                    this.disabledForm = false
                    break;
                case false: 
                    this.is_edit = false 
                    this.disabledForm = true
                    break;
                case 'true': 
                    this.is_edit = true 
                    this.disabledForm = false
                    break;
                case 'false': 
                    this.is_edit = false 
                    this.disabledForm = true
                    break;
                default: 
                    this.is_edit = false 
                    this.disabledForm = true
                    break;
            } 

            if(!this.is_edit) {
                this.$store.state.title = 'Item Detail'
            }else {
                let permission_edit  = await this.$root.checkingButtonsPage(this.alias, 'update')
                if(!permission_edit.validate) {
                    this.disabledForm = true 
                }
            }

            this.init()

        }else {
           let permission_create =  await this.$root.checkingButtonsPage(this.alias, 'create')
           if(!permission_create.validate) {
                this.disabledForm = true 
           } 
        }

        let self = this
        $(document).ready(function(e) {
            $('.select-category').on('select2:select', (e) => {
                e.preventDefault();
                let data = e.params.data
                self.form.category = data.id
            })
        })

        $('.select2').select2()
        $('.select-category').select2()
    },
    methods: {
        async init() {
            if(this.id) {
                Rest.get('/item/'+this.id) 
                .then( async(res) => {
                    if(res && res.data) {
                        this.form.name = res.data.name 
                        this.form.is_active = res.data.is_active

                        if(res.data.description) {
                            this.form.description = res.data.description
                        }
                        
                        if(res.data.category) {
                            this.form.category = res.data.category
                            $('.select-category').val([res.data.category]).trigger('change')
                        }

                        if(res.data.item_images) {
                            res.data.item_images.sort(function(a, b) {
                                var keyA = new Date(a.updated_at)
                                var keyB = new Date(b.updated_at)
                                if (keyA < keyB) return -1;
                                if (keyA > keyB) return 1;
                                    return 0;
                            });

                            res.data.item_images.forEach( (item) => {
                                item.is_new = false 
                                item.is_errors = false
                            })
                            this.form.item_images = res.data.item_images
                            if(this.form.item_images.length < 5) {
                                let diff = 5 - this.form.item_images.length 
                                for (var i = 0; i < diff; i++) {
                                    this.form.item_images.push({
                                        image_path: null,
                                        is_new: true,
                                        is_errors: false,
                                        file: null,
                                    })
                                }
                            }
                        }
                    }
                })
                .catch( () => {
                    this.display404 = true 
                })
            }
        },
        changeBtnSwitch() {
            this.form.is_active = !this.form.is_active
        },
        async saveItemImage() {
            this.is_success_upload = true
            if(this.form && this.form.item_images && this.form.item_images.length > 0) {
                this.form.item_images.forEach( async(item, i) => {
                    if(item.file) {
                        await this.saveItemImageProcess(item.file, i)
                    }
                })
            }
        },
        async saveItemImageProcess(file, i) {
            if(file) {
                let params = new FormData()
                params.append('files', file)
                Rest.post('/storage/files',params)
                .then( async(res) => {
                    if(res && res.data && res.data.length > 0 ) {
                        this.form.item_images[i].image_path = res.data[0].path
                        this.form.item_images[i].file = null 
                        this.form.item_images[i].is_new = false
                        this.form.item_images[i].is_errors = false
                    }
                })
                .catch( async(err) => {
                    this.is_success_upload = false
                    if(err && err.response && err.response.status) {
                        if(err.response.data && err.response.data.message) {
                            this.$root.showNotification('Failed', 'error', err.response.data.message +' in item_image array '+i)        
                        }else {
                            var message = "item image upload failed"
                            this.$root.showNotification('Failed', 'error', message+ ' in item_image array '+i)
                        }
                    }else {
                        this.$root.showNotification('Failed', 'error', 'Sorry, you do not have an internet connection.')
                    }

                    return
                })
            }
        },
        async doSaveConfirm() {
            await this.saveItemImage()
            let is_valid = await this.validationForm()
            if(is_valid) {
                if(this.id) {
                    this.is_confirm = true 
                }else {
                    this.is_loading = true
                    const delay = ms => new Promise(res => setTimeout(res, ms))
                    await delay(5000);
                    await this.doSaveProcess()
                }
            }
        },
        async doSave() {
            this.is_confirm_loading = false
            
            await this.doSaveProcess()
        },
        async doSaveProcess() {
            if(this.is_success_upload) { 

                let is_error_upload = false
                let item_images = []
                this.form.item_images.forEach( (item) => {
                    if(item.image_path) {
                        if(item.file) {
                            is_error_upload = true
                        }else {
                            item_images.push({
                                image_path: item.image_path
                            })
                        }
                    }
                })

                if(is_error_upload) {
                    this.$root.showNotification('Failed', 'error', 'Item image upload failed')
                }else {
                    let params = {
                        name: this.form.name,
                        category: this.form.category,
                        description: this.form.description,
                        is_active: this.form.is_active,
                        item_images: item_images
                    }

                    let method = this.id ? 'put' : 'post'
                    let url = this.id ? '/item/'+this.id : '/item'
                    Rest[method](url, params)
                    .then( async(res) => {
                        if(res && res.status == 200) {
                            this.$root.showNotification('Success', 'success', this.id ? "Item modification successful." : "Item addition successful.")
                            this.userLogActivity()
                            this.$root.$router.push({
                                name: "master.item"
                            })
                        }
                    })
                    .catch( async(err) => {
                        if(err && err.response && err.response.status) {
                            if(err.response.data && err.response.data.message) {
                                this.$root.showNotification('Failed', 'error', err.response.data.message)        
                            }else {
                                var message = "Item addition failed"
                                if(this.id) {
                                    message = "Item modification failed."
                                }
                                this.$root.showNotification('Failed', 'error', message)
                            }
                        }else {
                            this.$root.showNotification('Failed', 'error', 'Sorry, you do not have an internet connection.')
                        }
                    })
                    .finally( () => {
                        this.is_confirm = false 
                        this.is_confirm_loading = false
                        this.is_loading = false
                    })
                }
            }
        },
        async validationForm() {
            let is_success = true 
            this.errors.name = false 
            this.errors.category = false 
            this.errors.description = false
            if(!this.form.name) {
                this.errors.name = true 
                this.is_success = false 
            }else {
                let length = this.form.name
                if(length < 3 || length > 20) {
                    this.errors.name = true 
                    is_success = false
                }
            }

            if(!this.form.category) {
                this.errors.category = true
                is_success = false
            }

            if(!this.form.description) {
                this.errors.description = true 
                is_success = false
            }else {
                let length = this.form.description 
                if(length < 3 || length > 255) {
                    this.errors.description = true 
                    is_success = false
                }
            }

            let item_image_validation = await this.itemImageValidation()
            if(!item_image_validation) {
                this.is_success = false
            }

            return is_success
        },
        changeUploadImage(data) {
            let image_url = window.URL.createObjectURL(data.file) 
            this.form.item_images[this.item_image_index].image_path = image_url
            this.form.item_images[this.item_image_index].is_new = true 
            this.form.item_images[this.item_image_index].is_errors = false
            this.form.item_images[this.item_image_index].file = data.file

        },
        async changeDeleteImage() {
            if(this.item_image_index >= 0) {
                this.form.item_images.forEach( (item, i) => {
                    if(i == this.item_image_index) {
                        item.image_path = null
                        item.is_new = true
                    }
                })
            }

            this.item_image_index = null
            this.image_disabled = true 
            this.image_path = null
            this.refreshFormItem()
            
        },
        imageUrl(data) {
            let base_url = process.env.VUE_APP_UPLOAD_URL
            let image_url = ''
            if(data.image_path) {
                if(data.is_new && data.file) {
                    image_url = data.image_path
                }else {
                    image_url = base_url+data.image_path
                }
            }
            
            return image_url
        },
        addItemImage(i) {
            if(!this.disabledForm) {
                $('.upload-item-image').click()
                this.item_image_add_index = i
            }
        },
        showImage(image_path, index) {
            this.image_path = image_path
            this.item_image_index = index
            if(!this.disabledForm) {
                this.image_disabled = false
            }
        },
        async uploadAddItemImageChange() {
            let possible_type = ['image/png', 'image/jpg', 'image/jpeg']
            let input =  document.getElementById('upload-item-image');
            let file = input.files[0]
            if(file.size <= 5000000) {
                if(possible_type.includes(file.type)) {
                    let image_url = window.URL.createObjectURL(file) 
                    this.form.item_images[this.item_image_add_index].image_path = image_url
                    this.form.item_images[this.item_image_add_index].is_new = true 
                    this.form.item_images[this.item_image_add_index].is_errors = false
                    this.form.item_images[this.item_image_add_index].file = file

                    this.item_image_index = this.item_image_add_index
                    this.image_disabled = false
                    this.image_path = image_url

                    this.refreshFormItem()
                    input.value = null
                }else {
                    this.$root.showNotification('Failed', 'error', 'Please, input item image using format image/png, image/jpg, image/jpeg')
                    input.value = null
                }
            }else {
                let your_file = file.size/1000000
                let max_file = your_file.toFixed(1)
                this.$root.showNotification('Failed', 'error', 'Your file exceeds '+max_file+'MB, the maximum file is 5MB.')
                input.value = null
            }
        },
        async refreshFormItem() {
            let item_images = []
            this.form.item_images.forEach( (item) => {
                if(item.image_path) {
                    item_images.push(item)
                }
            })

            let length = item_images.length
            let diff = 5 - length
            if(diff > 0) {
                for (let i = 0; i < diff; i++) {
                    item_images.push({
                        image_path: null,
                        is_new: true,
                        is_errors: false,
                        file: null,
                    })
                    
                }
            }

            this.form.item_images = item_images
            this.itemImageValidation()

        },
        async itemImageValidation() {
            let is_valid = false 
            this.form.item_images.forEach( (item) => {
                if(item.image_path) {
                    is_valid = true
                }
            })

            this.errors.item_images = !is_valid
            return is_valid
        },
        async userLogActivity() {
            if(this.$root.$store.state.user && this.$root.$store.state.user.full_name) {
                let route_name = {
                    name: 'master.item.form',
                    params: {
                        id: this.form.id
                    },
                    query: {
                        is_edit: false
                    }
                } 

                let secretKey = process.env.VUE_APP_KEY_ENCRYPT_DECRYPT
                let route_name_encrypt = this.EncryptDecryptAesCbc256.encryptAesCbc256(secretKey, JSON.stringify(route_name))

                let activity_type = 'create'
                let activity = `${this.$root.$store.state.user.full_name} has added a item with the name <a style="cursor: pointer" class="click-detail-log" data-route="${route_name_encrypt}"> ${this.form.name}</a>`
                if(this.id) {
                    activity = `${this.$root.$store.state.user.full_name} has modified the item with the name <a style="cursor: pointer" class="click-detail-log" data-route="${route_name_encrypt}"> ${this.form.name}</a>`
                    activity_type = 'edit'
                }

                let params = {
                    activity: activity,
                    feature: 'Item',
                    activity_type: activity_type,
                    route_name: route_name
                }

                this.$root.sendUserLogActivity(params)
            }
            
        },

    },
    computed: {
        calculate_description() {
            let length = 0
            if(this.form.description) {
                length = this.form.description.length
            }
            return length
        },
        
    },
    watch: {
        'form.name': {
            handler(val) {
                this.errors.name = false
                if(!val) {
                    this.errors.name = true 
                }else {
                    let length = val.length
                    if(length < 3 || length > 20) {
                        this.errors.name = true
                    }
                }
            }
        },
        'form.category': {
            handler(val) {
                this.errors.category = false
                if(!val) {
                    this.errors.category = true 
                }
            }
        },
        'form.description': {
            handler(val) {
                this.errors.description = false 
                if(!val) {
                    this.errors.description = true
                }else {
                    let length = val.length
                    if(length < 3 || length > 255) {
                        this.errors.description = true
                    }
                }
            }
        }
    }
}
</script>

<style scoped>
textarea {
  resize: none;
}

.inline-div {
        display: inline;
        padding: 10px;
    }

.div-item-image{
    display: inline-block;
    width: 117px;
    height: 107px;
    gap: 10px;
    border-radius: 8px 8px 8px 8px;
    border: 1px dashed #E0E0E0;
}

.btn-add-item-image {
    margin: auto;
    width: 50%;
    padding-top: 30px;
    padding-left: 5px;
}

.upload-item-image{
    display: none;
}
</style>